import React from 'react';
import logo from 'src/assets/img/logo.svg';
import styles from './LoginLayout.module.scss';

export const Logo = () => (
  <img src={logo} alt="Equine 74 logo" className={styles.logo} />
);
